import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeDollarSign' })
export class RemoveDollarSignPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace('$', '');
  }
}
